import { render, staticRenderFns } from "./AnnounceEditor.vue?vue&type=template&id=0d3e8ad8&scoped=true"
import script from "./AnnounceEditor.vue?vue&type=script&lang=js"
export * from "./AnnounceEditor.vue?vue&type=script&lang=js"
import style0 from "./AnnounceEditor.vue?vue&type=style&index=0&id=0d3e8ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e8ad8",
  null
  
)

export default component.exports